
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.1413 11.35V14.9112C14.1413 15.2262 14.1063 15.5237 14.0275 15.795C13.7038 17.0812 12.6363 17.8863 11.1663 17.8863H8.78625L6.14375 19.645C5.75 19.9162 5.225 19.6275 5.225 19.155V17.8863C4.3325 17.8863 3.58875 17.5888 3.0725 17.0725C2.5475 16.5475 2.25 15.8037 2.25 14.9112V11.35C2.25 9.6875 3.2825 8.54125 4.875 8.3925C4.98875 8.38375 5.1025 8.375 5.225 8.375H11.1663C12.9513 8.375 14.1413 9.565 14.1413 11.35Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16.0312 14.15C17.1425 14.15 18.0787 13.7825 18.7262 13.1263C19.3825 12.4788 19.75 11.5425 19.75 10.4313V5.96875C19.75 3.9125 18.0875 2.25 16.0312 2.25H8.59375C6.5375 2.25 4.875 3.9125 4.875 5.96875V6.625C4.875 6.87 5.0675 7.0625 5.3125 7.0625H11.1662C13.5375 7.0625 15.4538 8.97875 15.4538 11.35V13.7125C15.4538 13.9575 15.6462 14.15 15.8913 14.15H16.0312Z","fill":"currentColor"}})])
          )
        }
      }
    